import React, { useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  TreeSelect,
  Upload,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { PlusOutlined } from "@ant-design/icons";

type SizeType = Parameters<typeof Form>[0]["size"];
const onChange = (value: string) => {
  console.log(`selected ${value}`);
};

const onSearch = (value: string) => {
  console.log("search:", value);
};

const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

function BasicInformation() {
  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default"
  );

  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };

  return (
    <>
      <Form
        labelCol={{ span: 8 }}
        // wrapperCol={{ span: 14 }}
        layout="horizontal"
        initialValues={{ size: componentSize }}
        onValuesChange={onFormLayoutChange}
        size={componentSize as SizeType}
        // style={{ maxWidth: 600 }}
        className="grid grid-cols-3 gap-x-5"
      >
        <Form.Item label="كود الصنف">
          <InputNumber className="w-full" />
        </Form.Item>
        <Form.Item label="الرقم المرجعى">
          <InputNumber className="w-full" />
        </Form.Item>
        <Form.Item label="اسم الصنف عربى">
          <Input className="w-full" />
        </Form.Item>
        <Form.Item label="اسم الصنف انجليزى">
          <Input className="w-full" />
        </Form.Item>
        <Form.Item label="نوع الصنف">
          <Select
            showSearch
            placeholder=""
            optionFilterProp="label"
            onChange={onChange}
            onSearch={onSearch}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
              {
                value: "lucy",
                label: "Lucy",
              },
              {
                value: "tom",
                label: "Tom",
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="سعر الشراء ">
          <InputNumber className="w-full" />
        </Form.Item>
        <Form.Item label="الماركة">
          <Input className="w-full" />
        </Form.Item>
        <Form.Item label="بلد المنشأ">
          <Select
            showSearch
            placeholder=""
            optionFilterProp="label"
            onChange={onChange}
            onSearch={onSearch}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
              {
                value: "lucy",
                label: "Lucy",
              },
              {
                value: "tom",
                label: "Tom",
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="سعر البيع ">
          <InputNumber className="w-full" />
        </Form.Item>
        <Form.Item label="الموديل">
          <Input className="w-full" />
        </Form.Item>
        <Form.Item label="الحساب المرتبط">
          <Select
            showSearch
            placeholder=""
            optionFilterProp="label"
            onChange={onChange}
            onSearch={onSearch}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
              {
                value: "lucy",
                label: "Lucy",
              },
              {
                value: "tom",
                label: "Tom",
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="مركز التكلفه">
          <Select
            showSearch
            placeholder=""
            optionFilterProp="label"
            onChange={onChange}
            onSearch={onSearch}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
              {
                value: "lucy",
                label: "Lucy",
              },
              {
                value: "tom",
                label: "Tom",
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="له باركود">
          <Checkbox />
        </Form.Item>
        <Form.Item label="صنف مميز">
          <Checkbox />
        </Form.Item>
        <Form.Item label="صنف اون لاين">
          <Checkbox />
        </Form.Item>
        <Form.Item label="وصنف الصنف">
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item label="المخزن الافتراضى">
          <Select
            showSearch
            placeholder=""
            optionFilterProp="label"
            onChange={onChange}
            onSearch={onSearch}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
              {
                value: "lucy",
                label: "Lucy",
              },
              {
                value: "tom",
                label: "Tom",
              },
            ]}
          />
        </Form.Item>
      </Form>
      <div className="grid justify-end items-center">
        <Button
          type="primary"
          className="py-5 px-36 font-bold flex items-center justify-center"
        >
          حفظ
        </Button>
      </div>
    </>
  );
}

export default BasicInformation;
